import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import modules from './iconbtn.module.scss';
import sharedModules from '../shared.module.scss';
import StyledButton from '../StyledButton';
import withTheme from '../../hoc/withTheme';

const Icon = (props = {}) => {
    const { circle, className, icon, outline, solid, secondary, children, variant, CustomIcon, ...rest } = props

    return <StyledButton $outline={outline} $solid={solid} $variant={variant} className={`${sharedModules.button} ${modules.iconButton} ${circle ? modules.circle : ''} ${className}`.trim()} {...rest}>
        {CustomIcon ? <CustomIcon /> : <FontAwesomeIcon icon={icon} alt="" />}
        {children}
    </StyledButton>
}

Icon.defaultProps = {
    className: '',
    circle: true,
    variant: 'primary'
}

Icon.propTypes = {
    icon: PropTypes.oneOfType([PropTypes.element, PropTypes.object]).isRequired,
    variant: PropTypes.oneOf(['sendAction','primary', 'secondary', 'background', 'action', 'text'])
}

export default withTheme(Icon)